export const graphMockedData = [
  {
    filter: "Todas Categorias / Machos e Femêas / Todas as Variedades",
    caracteristica: "DIPP",
    agrupamentos: [
      {
        legenda: "Estância São Luiz dos Coqueiros",
        data: [
          {
            safra: 2010,
            media: 8.109,
            n: 59,
          },
          {
            safra: 2011,
            media: 9.109,
            n: 59,
          },
          {
            safra: 2012,
            media: 10.109,
            n: 59,
          },
          {
            safra: 2013,
            media: 9.109,
            n: 59,
          },
          {
            safra: 2014,
            media: 4.109,
            n: 59,
          },
          {
            safra: 2015,
            media: 12.109,
            n: 59,
          },
        ],
      },
      {
        legenda: "Programa",
        data: [
          {
            safra: 2010,
            media: 7.712,
            n: 92548,
          },
          {
            safra: 2011,
            media: 8.648,
            n: 92594,
          },
          {
            safra: 2012,
            media: 10.109,
            n: 59,
          },
          {
            safra: 2013,
            media: 13.109,
            n: 59,
          },
          {
            safra: 2014,
            media: 5.109,
            n: 59,
          },
          {
            safra: 2015,
            media: 11.109,
            n: 59,
          },
        ],
      },
      {
        legenda: "Fazendas G2",
        data: [
          {
            safra: 2010,
            media: 9.712,
            n: 92548,
          },
          {
            safra: 2011,
            media: 2.648,
            n: 92594,
          },
          {
            safra: 2012,
            media: 11.109,
            n: 59,
          },
          {
            safra: 2013,
            media: 12.109,
            n: 59,
          },
          {
            safra: 2014,
            media: 6.109,
            n: 59,
          },
          {
            safra: 2015,
            media: 6.109,
            n: 59,
          },
        ],
      },
    ],
  },
  {
    filter: "Todas Categorias / Machos e Femêas / Todas as Variedades",
    caracteristica: "MTGe",
    agrupamentos: [
      {
        legenda: "Estância São Luiz dos Coqueiros",
        data: [
          {
            safra: 2010,
            media: 8.109,
            n: 59,
          },
          {
            safra: 2011,
            media: 9.109,
            n: 59,
          },
          {
            safra: 2012,
            media: 10.109,
            n: 59,
          },
          {
            safra: 2013,
            media: 9.109,
            n: 59,
          },
          {
            safra: 2014,
            media: 4.109,
            n: 59,
          },
          {
            safra: 2015,
            media: 12.109,
            n: 59,
          },
        ],
      },
      {
        legenda: "Programa",
        data: [
          {
            safra: 2010,
            media: 7.712,
            n: 92548,
          },
          {
            safra: 2011,
            media: 8.648,
            n: 92594,
          },
          {
            safra: 2012,
            media: 10.109,
            n: 59,
          },
          {
            safra: 2013,
            media: 13.109,
            n: 59,
          },
          {
            safra: 2014,
            media: 5.109,
            n: 59,
          },
          {
            safra: 2015,
            media: 11.109,
            n: 59,
          },
        ],
      },
      {
        legenda: "Fazendas G2",
        data: [
          {
            safra: 2010,
            media: 9.712,
            n: 92548,
          },
          {
            safra: 2011,
            media: 2.648,
            n: 92594,
          },
          {
            safra: 2012,
            media: 11.109,
            n: 59,
          },
          {
            safra: 2013,
            media: 12.109,
            n: 59,
          },
          {
            safra: 2014,
            media: 6.109,
            n: 59,
          },
          {
            safra: 2015,
            media: 6.109,
            n: 59,
          },
        ],
      },
    ],
  },
];
